import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface HospitalContextState {
    selectedHospitalId: number | null
}

const STORAGE_KEY = 'atendimento_selected_hospital'

const loadInitial = (): HospitalContextState => {
    if (typeof window === 'undefined') return { selectedHospitalId: null }
    try {
        const raw = localStorage.getItem(STORAGE_KEY)
        if (!raw) return { selectedHospitalId: null }
        const id = parseInt(raw, 10)
        return { selectedHospitalId: Number.isFinite(id) ? id : null }
    } catch {
        return { selectedHospitalId: null }
    }
}

const hospitalContextSlice = createSlice({
    name: 'hospitalContext',
    initialState: loadInitial(),
    reducers: {
        setSelectedHospital(state, action: PayloadAction<number | null>) {
            state.selectedHospitalId = action.payload
            if (typeof window !== 'undefined') {
                if (action.payload != null) {
                    localStorage.setItem(STORAGE_KEY, String(action.payload))
                } else {
                    localStorage.removeItem(STORAGE_KEY)
                }
            }
        },
        clearSelectedHospital(state) {
            state.selectedHospitalId = null
            if (typeof window !== 'undefined') {
                localStorage.removeItem(STORAGE_KEY)
            }
        },
    },
})

export const { setSelectedHospital, clearSelectedHospital } = hospitalContextSlice.actions
export default hospitalContextSlice.reducer
